import React from 'react';
import { Modal } from '@/components';

import { BuyStampsFlow } from './buy-stamps-flow';

interface BuyStampsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const BuyStampsModal: React.FC<BuyStampsModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <BuyStampsFlow onSuccess={() => setTimeout(() => onClose(), 4000)} />
    </Modal>
  );
};